/**
 * @author Jersson Morales
 * @Copyright (c) Infotrack. All rights reserved.
 */
import ProveedorEstado from '@infotrack/presentacion-componentes/proveedorEstado';
import React from 'react';
import FormualrioModuloCV from './controladorVista/formularioModuloCV';
import TablaModuloCV from './controladorVista/tablaModuloCV';
import { estadoIncial, reductor } from './reductorModulo';

const Modulo: React.FunctionComponent = () => (
    <ProveedorEstado estadoInicial={estadoIncial} reductor={reductor}>
        <TablaModuloCV />
        <FormualrioModuloCV />
    </ProveedorEstado>
);

export default Modulo;
